import { createStore } from 'vuex';
import user from './modules/user';
import follow from './modules/follow';
import calendar from './modules/calendar';
import event from './modules/event';
import weekly from './modules/weekly';
import task from './modules/task';

// 后台接口返回参数类
export interface IAxiosResponseData {
    status: number;
    message: string;
    data: any;
}

export default createStore({
    modules: {
        user,
        follow,
        calendar,
        event,
        weekly,
        task,
    },
});
